import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { mainURL, prodURL } from "../utils/common";
import { DownloadFileByFileStoreId } from "./DownloadFileByFileStoreId";

export const LicenceLeftMenu = () => {
  const { t } = useTranslation();

  return (
    <nav className="sidebar card py-2 mb-4">
      <ul className="nav flex-column" id="nav_accordion">
        <li className="nav-item">
          <DownloadFileByFileStoreId
            fileStoreId={"8c5e58f7-41a1-40e4-aa1b-85b9b52fc1d4"}
            label={"Certificate of Enlistment - Guideline"}
          />
        </li>
        <li className="nav-item">
          <DownloadFileByFileStoreId
            fileStoreId={"ff6acaff-49f6-4931-bc5b-b56ffbb83f5d"}
            label={"Certificate of Enlistment - Procedure"}
          />
        </li>
        <li className="nav-item">
          <Link
            className="nav-link fontSizeClass"
            to="/Requirements_For_Obtaining_CE"
          >
            {t("Requirements for CE")}
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link fontSizeClass" to="/List_of_unit_offices">
            {t("List of Unit Offices (Licence)")}
          </Link>
        </li>
        <li className="nav-item">
          <a
            className="nav-link fontSizeClass"
            data-toggle="modal"
            data-target="#exampleModal"
            href=""
          >
            {t("View CE Information")}
          </a>
        </li>
        <div
          class="modal fade"
          id="exampleModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  Modal title
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                {t(
                  " Manufacture,import,stock,distribution,sell and use of single use plastic items and use of Plastic carry bags below 120 microns is prohibited. Sellers and buyers of Plastic Carry Bags etc. (for each stance) will be fined @ Rs 500/- and Rs 50/- respectively. As per decision of KMC authority it is mandatory within the KMC jurisdiction to include the Bengali Language on top of all signboards, hoardings and signage, alongside any other languages for carrying on trade and business activities by private ownership entities viz. shops, companies, shopping malls, offices, Restaurants, Hotels, Hospitals, Diagnostics Centers etc."
                )}
              </div>
              <div class="modal-footer">
                <a class="btn btn-primary" href={`${mainURL}/enlistment-fe/viewCeSearch`} >
                  {t("OK")}
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* <li className="nav-item">
                  <a className="nav-link fontSizeClass" href='https://kmcuat.wb.gov.in/enlistment-fe/viewCeSearch'> {t("View CE Information")} </a>
                </li> */}
        <li className="nav-item">
          <a
            class="nav-link fontSizeClass"
            href={`${mainURL}/citizen/language-selection`}
          >
            {t("Online Application Registration(For New CE)")}
          </a>
        </li>
        <li className="nav-item">
          <a
            class="nav-link fontSizeClass"
            href={`${mainURL}/citizen/language-selection`}
          >
            {t("Online Application For Change(For Existing CE)")}
          </a>
        </li>
        <li className="nav-item">
          <a
            class="nav-link fontSizeClass"
            href={`${mainURL}/citizen/language-selection`}
          >
            {t("Online Application For Closure(For Existing CE)")}
          </a>
        </li>
        <li className="nav-item">
          <a
            className="nav-link fontSizeClass"
            href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"4e1e0553-871e-4a36-b6d1-96020538df67"}&tenantId=km.kolkata`}
          >
            {t(
              "Modalities of Corrections of Name of Certificate of Enlistment Holder"
            )}
          </a>
        </li>
        <li className="nav-item">
          <a
            className="nav-link fontSizeClass"
            href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"3f954239-0ba9-4044-a8ca-24acf30ec2db"}&tenantId=km.kolkata`}
          >
            {t(
              "Documents required for update, change or register the mobile number"
            )}
          </a>
        </li>

        <li className="nav-item">
          <a
            class="nav-link fontSizeClass"
            href={`${mainURL}/citizen/language-selection`}
          >
            {t(
              "Online Renewal Application Registration(For Existing Defaulter CE)"
            )}
          </a>
        </li>

        {/* <li className="nav-item">
                  <a class="nav-link fontSizeClass" href={`${mainURL}/citizen/language-selection`}> {t("Online Application Search Status(For New CE)")}</a>
                </li> */}
        <li className="nav-item">
          <a
            class="nav-link fontSizeClass"
            href={`${mainURL}/citizen/language-selection`}
          >
            {t("My Application Status")}
          </a>
        </li>

        <li className="nav-item">
          <a
            class="nav-link fontSizeClass"
            href={`${mainURL}/citizen/language-selection`}
          >
            {t("Online application for Dog Registration")}
          </a>
        </li>
        <li className="nav-item">
          <a
            class="nav-link fontSizeClass"
            href={`${mainURL}/citizen/language-selection`}
          >
            {t("Online application for Temporary CE")}
          </a>
        </li>

        {/* <li className="nav-item">
                  <a class="nav-link fontSizeClass" href={`${mainURL}/citizen/language-selection`}> {t("Check Demands Payable")} </a>
                </li> */}

        <li className="nav-item">
          <a
            class="nav-link fontSizeClass"
            href={`${mainURL}/enlistment-fe/unpaiddemand`}>
            {t("Unpaid Demand Search")}
          </a>
        </li>
        {/* <li className="nav-item">
                  <a class="nav-link fontSizeClass" href={`${mainURL}/citizen/language-selection`}> {t("Unpaid Demand Search")} </a>
                </li> */}
        <li className="nav-item">
          <a className="nav-link fontSizeClass"
            data-toggle="modal" data-target="#exampleModal1" href="">
            {t("Get CE No (From Manual Bailiff CE)")}
          </a>
        </li>

        {/* <li className="nav-item">
                  <a className="nav-link fontSizeClass" data-toggle="modal"  data-target="#exampleModal1" href=''> {t("Print Unpaid Demand")} </a>
                </li> */}
        <div class="modal fade" id="exampleModal1" tabindex="-1"
          aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">
                  www.kmcgov.in says
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                {t(
                  " Manufacture,import,stock,distribution,sell and use of single use plastic items and use of Plastic carry bags below 120 microns is prohibited. Sellers and buyers of Plastic Carry Bags etc. (for each stance) will be fined @ Rs 500/- and Rs 50/- respectively. As per decision of KMC authority it is mandatory within the KMC jurisdiction to include the Bengali Language on top of all signboards, hoardings and signage, alongside any other languages for carrying on trade and business activities by private ownership entities viz. shops, companies, shopping malls, offices, Restaurants, Hotels, Hospitals, Diagnostics Centers etc."
                )}
              </div>
              <div class="modal-footer">
                <a
                  class="btn btn-primary"
                  href={`${mainURL}/enlistment-fe/searchcebailif`}
                >
                  {t("OK")}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* <li className="nav-item">
                  <a className="nav-link fontSizeClass" href='https://www.kmcgov.in/KMCPortal/jsp/LicenseUnpaidDemandSearchPrint.jsp'> {t("Print Unpaid Demand")}</a>
                </li> */}
        <li className="nav-item">
          <Link
            className="nav-link fontSizeClass"
            to="/Current_Circular_Notes_Guidelines">
            {t("Current Circular Notes & Guidelines")}
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link fontSizeClass"
            to="/Duplicate_Demand_Issuing_Offices">
            {t("Duplicate Demand Issuing Offices")}
          </Link>
        </li>
        <li className="nav-item">
          <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18080426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
            {t("Fees & Charges")}
          </a>
        </li>
        <li className="nav-item">
          <Link className="nav-link fontSizeClass" to="/Licence_download_form">
            {t("Download Forms")}
          </Link>
        </li>
        <li className="nav-item">
          <a
            class="nav-link fontSizeClass"
            href={`${mainURL}/citizen/withoutAuth/license-payment?screenType=main`}>
            {t("Make Online Payment")}
          </a>
        </li>
        <li className="nav-item">
          <a class="nav-link fontSizeClass" href={`${mainURL}/citizen/language-selection`}>
            {t("Reprint e-Receipt cum CE")}
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link fontSizeClass" href={`${prodURL}/contact-us/departmentContacts`}>
            {t("Contact Details")}
          </a>
        </li>
        <li className="nav-item">
          <a
            href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18080526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
          >
            {t(
              "Online Survey for Industry Sector Key Performance Indicators under Vision, Mission Exercise"
            )}
          </a>
        </li>
        <li className="nav-item">
          <a
            href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18080626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
          >
            {t(
              "Policy for use of pet Coke and Furnace Oil as a Fuel in the State of West Bengal"
            )}
          </a>
        </li>
      </ul>
    </nav>
  );
};
